import { Component, output, input, ChangeDetectionStrategy } from '@angular/core';

import { IconButtonComponent } from '../../../common/button/components/icon-button/icon-button.component';
import { GroupComponent } from '../../../common/group/group.component';
import { InputComponent } from '../../../forms/input/input.component';
import { ClipboardCopy } from '../clipboard-copy.service';

@Component({
  selector: 'rt-copy-input',
  styleUrls: ['./copy-input.component.less'],
  templateUrl: 'copy-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [GroupComponent, InputComponent, IconButtonComponent],
})
export class CopyInputComponent {
  public readonly value = input<string>(undefined!);
  public readonly hasOpenInNewTabButton = input<boolean>(false);
  public readonly hasCopyButton = input<boolean>(true);
  public readonly hasEditButton = input<boolean>(false);
  public copied = output<void>();
  public edit = output<void>();

  constructor(private clipboardCopy: ClipboardCopy) {}

  public copy(element: InputComponent): void {
    this.clipboardCopy.fromHtmlElement(element.input.nativeElement);
    this.copied.emit();
  }

  public onEdit(): void {
    this.edit.emit();
  }
}
